import sessionOfferTypes from "astrid-firestore/src/constants/sessionOfferTypes";

export default function sessionIsAnyRecorderInTeam(recorder) {
	return recorder === sessionOfferTypes.ANY_RECORDER_IN_TEAM || recorder === null;
}
